module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("43Aa1"))).then(() => parcelRequire('ikE14'));